import { composeDataModules } from '@perpay-web/data-module/composeDataModules';
import { fetchAutoPaySchedulesDataModule } from '@perpay-web/fintech/dataModules/fetchAutoPaySchedules';
import { fetchBankAccountsDataModule } from '@perpay-web/fintech/dataModules/fetchBankAccounts';
import {
    fetchCardAccountsDataModule,
    getCardAccountStatus,
    getHasCardAccount,
} from '@perpay-web/fintech/dataModules/fetchCardAccounts';
import { fetchCardActivityDataModule } from '@perpay-web/fintech/dataModules/fetchCardActivity';
import { fetchCardStatementsDataModule } from '@perpay-web/fintech/dataModules/fetchCardStatements';
import { fetchInitiatedAutoPayPaymentsDataModule } from '@perpay-web/fintech/dataModules/fetchInitiatedAutoPayPayments';

const dataModules = [
    fetchCardAccountsDataModule,
    fetchCardStatementsDataModule,
    fetchAutoPaySchedulesDataModule,
    fetchInitiatedAutoPayPaymentsDataModule,
    fetchBankAccountsDataModule,
    fetchCardActivityDataModule,
];

const FetchCardDetailsDataModule = composeDataModules(dataModules);

const getRoot = (state) => state.dataModules.fetchCardDetailsV2;

export const fetchCardDetailsV2DataModule = FetchCardDetailsDataModule({
    getRoot,
    key: 'FETCH_CARD_DETAILS_V2',
});

export { getCardAccountStatus, getHasCardAccount };
